import { render, staticRenderFns } from "./DSSwitcher.vue?vue&type=template&id=0325defd&scoped=true&"
import script from "./DSSwitcher.vue?vue&type=script&lang=ts&"
export * from "./DSSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./DSSwitcher.vue?vue&type=style&index=0&id=0325defd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0325defd",
  null
  
)

export default component.exports